import { SET_USER_TYPE, SET_PERMISSION, SET_ACCESS_LIST, SET_CURRENT_USER, SET_PREFERENCE, SET_SEAT_EXPIRED, CLEAR_ALL } from './activeUserTypes';

const initialState = {
    currentUser: {},
    preference: {},
    permission: {},
    accessList: {},
    userType: 'reporter',
    userSeatExpired: false,
    loading: false,
    error: null
};

export default function activeUserReducer(state = initialState, action) {
    switch (action.type) {
        case SET_USER_TYPE:
            return { ...state, userType: action.payload };
        case SET_PERMISSION:
            return { ...state, permission: action.payload };
        case SET_ACCESS_LIST:
            return { ...state, accessList: action.payload };
        case SET_CURRENT_USER:
            return { ...state, currentUser: action.payload };
        case SET_PREFERENCE:
            return { ...state, preference: action.payload };
        case SET_SEAT_EXPIRED:
            return { ...state, userSeatExpired: action.payload };
        case CLEAR_ALL:
            return initialState;
        default:
            return state;
    }
}
